import i18next from 'i18next';
import React from 'react';

import { Button } from '@commons/utils/styledLibraryComponents';
import { GenericSaveButton } from '@commons/Buttons';
import { getTheme } from '@commons/utils/theme';

export const UpdatePublicApiFormActionButtons = ({
  isValid,
  isSubmitting,
  onDelete,
  onUpdateSubmit,
}) => {
  const theme = getTheme();

  return (
    <>
      <Button
        buttonCustomStyle={{
          justifyContent: 'center',
          gap: '8px',
          color: theme.colors.infoRed,
          border: `2px solid ${theme.colors.infoRed}`,
          backgroundColor: theme.colors.white,
        }}
        color={'inpulse-default'}
        handleClick={onDelete}
        icon={'/images/icon-delete-trash-red.svg'}
        iconCustomStyle={{ width: '14px', height: '14px' }}
        label={i18next.t('GENERAL.DELETE')}
        minWidth={220}
      />
      <GenericSaveButton
        handleClick={onUpdateSubmit}
        isDisabled={!isValid || isSubmitting}
        minWidth={220}
      />
    </>
  );
};
